export function marqueeButton() {
    const buttons = document.querySelectorAll('[data-marquee-button]');
    const INVIEW_CLASS = 'is--inview';

    if (!buttons.length) return;

    buttons.forEach((button) => {
        ScrollTrigger.create({
            trigger: button,
            start: 'top bottom',
            end: 'bottom top',
            onEnter: () => button.classList.add(INVIEW_CLASS),
            onEnterBack: () => button.classList.add(INVIEW_CLASS),
            onLeave: () => button.classList.remove(INVIEW_CLASS),
            onLeaveBack: () => button.classList.remove(INVIEW_CLASS),
        });
    });
}